export default __webpack_public_path__ + "static/media/Rubber_stopper.e42a873c.svg";